import React from 'react';
import { styled } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { noop } from 'lodash-es';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';

const Title = styled.div`
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border-top: 1px solid ${(props) => props.theme.colors.brand['300']};
  background: ${(props) => props.theme.colors.brand['200']};
  padding: 0 ${(props) => props.theme.space.xs};
  color: ${(props) => props.theme.colors.neutral['700']};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`;

const DSMobileContextMenuGroup = ({ title, isMulti, singleSelect, children, value: groupValue, selectedItems }) => (
  <Grid>
    <Grid>
      <Title>{title}</Title>
    </Grid>
    <Grid>
      {React.Children.map(children, (child, index) => {
        const { onClick = noop } = child.props;
        const value = `${groupValue}:${index}`;
        let isSelected;
        if (singleSelect) isSelected = selectedItems === value;
        else if (isMulti) isSelected = selectedItems.includes(value);
        return React.cloneElement(child, {
          value,
          key: 'group.'.concat(index),
          isGroup: true,
          isMulti,
          singleSelect,
          isSelected,
          onClick: (e) => onClick(e, { value, ...child.props }),
        });
      })}
    </Grid>
  </Grid>
);

const props = {
  /**
   * Group title
   */
  title: PropTypes.string.isRequired.description('group title'),
  /**
   *  Array of MobileContextMenuItem
   */
  children: PropTypes.node.isRequired.description('Array of MobileContextMenuItem'),
  /** multi select */
  isMulti: PropTypes.bool.description('multi select'),
  /** single select */
  singleSelect: PropTypes.bool.description('single select'),
  /** value for select */
  value: PropTypes.string.description('value for select'),
  /** selected items, array for multi, string for single */
  selectedItems: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).description(
    'selected items, array for multi, string for single',
  ),
};

DSMobileContextMenuGroup.componentType = 'DSMobileContextMenuGroup';
DSMobileContextMenuGroup.displayName = 'DSMobileContextMenuGroup';
const DSMobileContextMenuGroupWithSchema = describe(DSMobileContextMenuGroup);

DSMobileContextMenuGroupWithSchema.propTypes = props;

export { DSMobileContextMenuGroup, DSMobileContextMenuGroupWithSchema };
